import type { RatingValueType } from './Rating';

const RATING_POSITIVE_MIN_COUNT = 7;
const RATING_NEGATIVE_MAX_COUNT = 5;

export const presentRatingValueType = ({ value }: { value: number | null }): RatingValueType => {
    if (!value) {
        return 'unknown';
    }

    if (value >= RATING_POSITIVE_MIN_COUNT) {
        return 'positive';
    }

    if (value < RATING_NEGATIVE_MAX_COUNT) {
        return 'negative';
    }

    return 'neutral';
};
